import './index.css';
import './index.less';



// WEBPACK FOOTER //
// ./ecology9/wea-left-right-layout/style/index.js